import { makeStyles } from '@mui/styles';

import Colors from 'configs/Colors';

const useStyles = makeStyles(() => ({
  container: {
    marginTop: 24,
  },
  heading: {
    fontSize: 18,
    fontWeight: 700,
    marginBottom: 16,
  },
  commentItem: {
    marginBottom: 24,
  },
  commentHeader: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 12,
    marginBottom: 8,
  },
  avatar: {
    width: 40,
    height: 40,
  },
  commentMeta: {
    display: 'flex',
    flexDirection: 'column',
  },
  collectorName: {
    fontSize: 14,
    fontWeight: 700,
    color: Colors.Black,
  },
  commentDate: {
    fontSize: 12,
    color: Colors.Grey6,
  },
  commentContent: {
    fontSize: 14,
    color: Colors.Black,
    lineHeight: 1.5,
  },
}));

export default useStyles;
